import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DashboardlistComponent } from "./_qform/partials/dashboardlist/dashboardlist.component";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./pages/layout.module").then((m) => m.LayoutModule),
  },

  { path: "**", redirectTo: "error/404" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
